export const getSanitisedValue = (value) =>
  value
    .replace(/["'=!+#*~;^()<>[\],&]/g, "")
    .replace(/\s{2,}/g, " ")
    .trim();
